import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';

import UserDataCell from '../ObjectVuls/UserDataCell';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { PeriodReportListItem } from 'api/periodReports/type';

interface PeriodReportExpandableProps {
  data: PeriodReportListItem;
}
const PeriodReportExpandable: React.FC<PeriodReportExpandableProps> = ({ data }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);

  return (
    <div className="d-flex w-100 flex-column">
      {tablet && (
        <>
          <div className="d-flex flex-wrap gap-2 my-2 mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('PeriodReportList.created_by')}</span>
            </div>
            <div>
              <UserDataCell user={data.created_by} />
            </div>
          </div>
          <div className="d-flex flex-wrap gap-2 my-2 mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('PeriodReportList.create_date')}</span>
            </div>
            <div>{dayjs(data.call_date).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm')}</div>
          </div>
        </>
      )}

      {mobile && (
        <>
          <div className="d-flex flex-wrap gap-2 my-2 mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('PeriodReportList.end_date')}</span>
            </div>
            <div>{data.end_date}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default PeriodReportExpandable;
